
const state = {
    flexworkers: [],
    flexworker: {}
}

export default state
